export default {
  nl: {
    title: 'Details {year} - {period}',
    titleGeneric: 'Details',
    selectColumns: 'Kolommen selecteren',
    export: 'Exporteren',
    exportFilename: 'VlecadInsights',
    materialOverview: 'Materiaaloverzicht',
    fields: {
      id: 'ID',
      client: 'Klant',
      parts: 'Onderdelen',
      boards: 'Platen',
      commission: 'Commissie',
      materialName: 'Materiaalnaam',
      thickness: 'Dikte',
      jobs: 'Opdrachten',
      machines: 'Machines',
      productionMethod: 'Productiemethode'
    },
    chart: {
      net: 'Netto%',
      rest: 'Rest%',
      cuttingWaste: 'Zaagafval%',
      waste: 'Afval%'
    },
    errors: {
      noExportData: 'Er zijn geen gegevens beschikbaar om te exporteren.',
      network: 'De server is niet bereikbaar. Controleer je verbinding en probeer het opnieuw.',
      compositionLoadFailed: 'De compositiegegevens konden niet worden opgehaald. Probeer het opnieuw.',
      productionPartsLoadFailed: 'De productieonderdelen konden niet worden opgehaald. Probeer het opnieuw.',
      documentsLoadFailed: 'De documentdetails konden niet worden opgehaald. Probeer het opnieuw.'
    }
  },
  en: {
    title: 'Details {year} - {period}',
    titleGeneric: 'Details',
    selectColumns: 'Select columns',
    export: 'Export',
    exportFilename: 'VlecadInsights',
    materialOverview: 'Material overview',
    fields: {
      id: 'ID',
      client: 'Client',
      parts: 'Parts',
      boards: 'Boards',
      commission: 'Commission',
      materialName: 'Material name',
      thickness: 'Thickness',
      jobs: 'Orders',
      machines: 'Machines',
      productionMethod: 'Production method'
    },
    chart: {
      net: 'Net %',
      rest: 'Remnant %',
      cuttingWaste: 'Saw waste %',
      waste: 'Waste %'
    },
    errors: {
      noExportData: 'There is no data available to export.',
      network: 'The server cannot be reached. Check your connection and try again.',
      compositionLoadFailed: 'The composition data could not be loaded. Please try again.',
      productionPartsLoadFailed: 'The production parts could not be loaded. Please try again.',
      documentsLoadFailed: 'The document details could not be loaded. Please try again.'
    }
  },
  fr: {
    title: 'Détails {year} - {period}',
    titleGeneric: 'Détails',
    selectColumns: 'Sélectionner les colonnes',
    export: 'Exporter',
    exportFilename: 'VlecadInsights',
    materialOverview: 'Aperçu des matériaux',
    fields: {
      id: 'ID',
      client: 'Client',
      parts: 'Pièces',
      boards: 'Panneaux',
      commission: 'Commission',
      materialName: 'Nom du matériau',
      thickness: 'Épaisseur',
      jobs: 'Commandes',
      machines: 'Machines',
      productionMethod: 'Mode de production'
    },
    chart: {
      net: 'Net %',
      rest: 'Chute réutilisable %',
      cuttingWaste: 'Trait de scie %',
      waste: 'Déchet %'
    },
    errors: {
      noExportData: 'Aucune donnée n’est disponible pour l’exportation.',
      network: 'Le serveur est inaccessible. Vérifiez votre connexion et réessayez.',
      compositionLoadFailed: 'Les données de composition n’ont pas pu être chargées. Veuillez réessayer.',
      productionPartsLoadFailed: 'Les pièces de production n’ont pas pu être chargées. Veuillez réessayer.',
      documentsLoadFailed: 'Les détails des documents n’ont pas pu être chargés. Veuillez réessayer.'
    }
  },
  de: {
    title: 'Details {year} - {period}',
    titleGeneric: 'Details',
    selectColumns: 'Spalten auswählen',
    export: 'Exportieren',
    exportFilename: 'VlecadInsights',
    materialOverview: 'Materialübersicht',
    fields: {
      id: 'ID',
      client: 'Kunde',
      parts: 'Teile',
      boards: 'Platten',
      commission: 'Kommission',
      materialName: 'Materialname',
      thickness: 'Dicke',
      jobs: 'Aufträge',
      machines: 'Maschinen',
      productionMethod: 'Produktionsmethode'
    },
    chart: {
      net: 'Netto %',
      rest: 'Rest %',
      cuttingWaste: 'Sägeabfall %',
      waste: 'Abfall %'
    },
    errors: {
      noExportData: 'Es sind keine Daten zum Exportieren verfügbar.',
      network: 'Der Server ist nicht erreichbar. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      compositionLoadFailed: 'Die Zusammensetzungsdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
      productionPartsLoadFailed: 'Die Produktionsteile konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
      documentsLoadFailed: 'Die Dokumentdetails konnten nicht geladen werden. Bitte versuchen Sie es erneut.'
    }
  }
};
